import React, { useContext, useEffect, useRef } from 'react';

import { useField, useForm, useFormState } from 'react-final-form';

import { ProjectIssueTypesContext } from '@qality/common-components/src/lib/ProjectIssueTypesProvider';
import {
  ProjectService,
  StorageOfUniqueServices,
} from '@qality/common-service';

import { UploadFilesView } from './UploadFiles.view';

export const UploadFiles = () => {
  const projectRef = useRef();
  const { input } = useField('project');
  const { change } = useForm();
  const {
    values: { mapping, project: { key: projectKey } = {} },
  } = useFormState();
  const { projectKey: providerProjectKey, fetchIssueTypes } = useContext(
    ProjectIssueTypesContext
  );

  useEffect(() => {
    if (projectKey) {
      fetchIssueTypes(projectKey);

      /** Remove mapping as it could be non relevant for another project */
      if (providerProjectKey !== projectKey) {
        const updatedMapping = mapping.map((mappingValue) => ({
          from: mappingValue.from,
          to: null,
        }));

        change('mapping', updatedMapping);
      }
    }
  }, [projectKey]);

  useEffect(() => {
    const fetchDefaultProject = async () => {
      const projectKeyFromStorage = await StorageOfUniqueServices.get(
        'ContextParamsService'
      ).getProjectIdOrKey();
      if (projectKeyFromStorage) {
        const projectObject = await ProjectService.getProject(
          projectKeyFromStorage
        );
        const projectOption = {
          label: projectObject.name + ` (${projectObject.key})`,
          value: projectObject.id,
          name: projectObject.name,
          id: projectObject.id,
          key: projectObject.key,
        };
        if (!projectRef.current) {
          change('project', projectOption);
        }
      }
    };
    fetchDefaultProject();
  }, [change]);

  useEffect(() => {
    if (input.value) {
      projectRef.current = input.value;
    }
  }, [input]);

  return <UploadFilesView />;
};
